import amazon from "../images/project-img/amazon.jpeg";
import cart from "../images/project-img/Cart.png";
import game from "../images/project-img/Game.png";
import modal from "../images/project-img/modal.png";
import quiz from "../images/project-img/tik.png";
import socialMedia from "../images/project-img/social.png";
import weather from "../images/project-img/Weather-app.png";
import messenger from "../images/project-img/messenger.png";
import rest from "../images/project-img/restNode.png";
import ecommerce from "../images/project-img/Ecomerse.png";
import startup from "../images/lasha_gif_2.gif";
import todo from "../images/project-img/todo.png";

export const projects = [
  {
    id: 22,
    name: "Startup.gov.ge",
    img: startup,
    demo: "https://startup.gov.ge",
    github: null,
    decription:
      "I spearheaded a transformative overhaul of startup.gov.ge, breathing new life into a project that had remained stagnant since 2016. Embracing modern technology, I revamped the platform, infusing it with the dynamic capabilities of contemporary web development. With a focus on user experience, I crafted an intuitive interface that empowers users to effortlessly submit their innovative startup ideas. Behind the scenes, I implemented robust administrative functionalities, providing seamless management of website content updates and real-time application processing. This revitalization not only modernized the platform but also ensured its alignment with the evolving needs of its governmental mission.",
    technologies: ["confidential Information"],
    features: [
      "User-friendly interface for seamless application submission",
      "Efficient administrative panel for real-time management of website content and applications",
      "Secure handling of sensitive information",
      "Integration with existing governmental systems",
      "Streamlined application process for enhanced user experience",
      "Dynamic database management ",
      "Customizable website update functionalities",
      "Responsive design ensuring optimal viewing experience across all devices",
    ],
  },
  {
    id: 15,
    name: " Next JS Ecommerce website and Admin panel ",
    img: ecommerce,
    decription:
      " Next.js 13 e-commerce app that allows users to register as administrators or clients, each with specific features. Clients can shop for clothing, place orders, and explore various categories. Administrators can easily update product listings to keep the catalog current.The app offers a smooth Stripe payment process for secure transactions. Admins can efficiently manage order statuses, ensuring organized order fulfillment. Users can update and manage multiple delivery addresses for added convenience. The app is fully responsive, offering a visually appealing and user-friendly interface.",
    github: "https://github.com/slunecnicee/E-comerce/tree/main",
    demo: "https://e-comerce-iota-five.vercel.app/",
    technologies: [
      "Next.js",
      "Tailwind CSS",
      "Stripe",
      "MongoDB",
      "JWT",
      "FireBase",
    ],
    features: [
      "User registration as admin or client",
      "Product management for administrators (add and update products)",
      "Online shopping with the ability to place orders",
      "Browsing a wide range of clothing items",
      "Organized product categorization",
      "Secure payment processing through Stripe integration",
      "Order status management by administrators",
      "Address management with the option to add multiple addresses",
      "Polished design for server-side and client-side components",
      "Backend powered by Firebase for real-time functionality",
      "Data storage and retrieval handled seamlessly with MongoDB",
      "Fully responsive interface catering to various devices",
      "Aesthetically pleasing and user-friendly design",
    ],
  },
  {
    id: 1,
    name: " Mern Stack Social Media App",
    img: socialMedia,
    decription:
      "This MERN stack social media platform offers an intuitive interface reminiscent of leading platforms like Facebook. Users seamlessly connect, share image-rich posts, interact through likes and comments, and personalize their profiles, posts, and images. Effortless navigation through user profiles and a user-friendly search bar encourages connections. The application is responsive, ensuring a friendly experience on all screen sizes. ",
    github: "https://github.com/slunecnicee/Social-media-app",
    demo: "https://social-media-front-end-pi.vercel.app/login",
    technologies: ["React.js", "Node.js", "Express", "MongoDB", "Mui Material"],
    features: [
      "User registration as admin or client",
      "Product management for administrators (add and update products)",
      "Online shopping with the ability to place orders",
      "Browsing a wide range of clothing items",
      "Organized product categorization",
      "Secure payment processing through Stripe integration",
      "Order status management by administrators",
      "Address management with the option to add multiple addresses",
      "Sleek and responsive cart system",
      "Aesthetically pleasing and user-friendly design",
    ],
  },
  {
    id: 10,
    name: "Amazon-Clone",
    img: amazon,
    github: "https://github.com/slunecnicee/Amazon",
    demo: "https://amazon-ecommerce-sandy.vercel.app/",
    decription:
      "This project marks my culminating endeavor at Digital Institute. Project is an E-commerce web application, that resembles the look and feel of Amazon, with it's user-friendly interface and unique features. Front end is done and i would love to hear your thoughts. The  server side was provided by the institute, but i m currently working on developing exact same one with node js and express.",
    features: [
      "I am utilizing the institute-provided server infrastructure to establish API connections, retrieve product data, and facilitate user registration and sign-in processes.",
      "The application's design closely resembles that of Amazon, exhibiting a user-friendly interface and intuitive user experience.",
      "app is using stripe for the payment method",
      "App has very smooth login and registration process as well as user profile management and order management",
      "App is fully responsive and optimized for all screen sizes.",
    ],
    technologies: [
      "React.js",
      "Node Js",
      "MongoDB",
      "stripe",
      "express",
      "React-Redux",
      "Sass",
      "Mui Material",
    ],
  },
  {
    id: 58,
    name: "Powerfull To-Do app with Angular 17",
    img: todo,
    github: "https://github.com/slunecnicee/to-do-app-Angular",
    demo: "https://to-do-app-angular-seven.vercel.app/todo",
    decription:
      "This project is a simple yet powerful To-Do List application built with Angular 17 and PrimeNG. It features a clean user interface for managing your daily tasks with ease. The app uses PrimeNG UI components for Angular to deliver a responsive and accessible experience.",
    features: [
      "PowerFull task management",
      "Theme change with multiple themes",
      "Responsive Design",
      "User friendly interface",
    ],
    technologies: [
      "Angular",
      "PrimeNG",
      "PrimeIcons",
      "PrimeFlex",
      "RxJS",
      "TypeScript",
      "Zone.js",
    ],
  },

  {
    id: 3,
    name: "Weather App with Next.js and TypeScript",
    img: weather,
    demo: "https://weather-app-one-pi-44.vercel.app/",
    github: "https://github.com/slunecnicee/weather-app",
    decription:
      '"This project is a weather app built with Next.js and TypeScript, featuring a sleek UI design using Tailwind CSS. It leverages a fake API from weatherapi.com to provide weather information. Users can search for any city, using capital letters, to access current weather conditions, weekly forecasts, and detailed weather information for the selected location, including the current date."',
    technologies: ["Next.js", "TypeScript", "Tailwind CSS"],
  },

  {
    id: 6,
    name: "todo-list, countdown-clock, X-O game and 5 question quizz",
    img: quiz,
    demo: "https://countdown-todo-quizz.vercel.app/",
    github: "https://github.com/slunecnicee/countdown-todo-quizz",
    decription:
      "This application offers a range of functionalities, including a to-do list for task management, a countdown timer set to May 30th, 3024, simple 2 player Tik-Tak-Toe game and a quiz featuring five questions inspired by the popular TV show 'Big Bang Theory.' It combines productivity with entertainment, catering to various user needs and interests.",
    technologies: ["React.js"],
  },

  {
    id: 7,
    name: "Big Bang Theory game Rock-Paper-Scissors-Lizard-Spock",
    img: game,
    demo: "https://rock-paper-scissors-lizard-spock-nine.vercel.app/",
    github: "https://github.com/slunecnicee/Rock-Paper-Scissors-Lizard-Spock",
    decription:
      "I have developed a game inspired by the popular TV show 'The Big Bang Theory,' featuring the classic 'Rock, Paper, Scissors, Lizard, Spock' game. This interactive game is built using HTML, JavaScript, and enhanced with styling using Css. You can listen to rules in case u are not familiar with them. Enjoy playing!",
    technologies: ["JavaScript", "HTML", "CSS"],
  },
  {
    id: 4,
    name: "Protected Route",
    img: modal,
    demo: "https://social-media-sign-in.vercel.app/",
    github: "https://github.com/slunecnicee/Social-Media-Sign-In",
    decription:
      "This project features a protected route system. Upon initial page load, users are directed to the home page, where access to the list of cocktails is restricted until a user logs in. Clicking the login button triggers a modal window displaying login credentials. The password is static and set as 'Aa12345,' as indicated on the home page. Users can log in with any username of their choice. Once logged in, users can view a list of cocktails retrieved from a fake API. Clicking on any cocktail item redirects the user to a detailed page dedicated to that specific cocktail. This detailed page includes a table presenting the cocktail's ingredients and other pertinent details.",
    technologies: [
      "React.js",
      "Redux",
      "React-Query",
      "Styled-components",
      "TypeScript",
    ],
  },
  {
    id: 5,
    name: "Shopping Cart with React-Redux",
    img: cart,
    demo: "https://shopping-cart-one-dun.vercel.app/",
    github: "https://github.com/slunecnicee/Shopping-Cart",
    decription:
      "This is a shopping cart project created with React and Redux, featuring integration with a free cocktails API to showcase various cocktails. Users can add these cocktails to their cart, and the header displays the quantity of items in the cart. Inside the cart component, users can increase the quantity of individual cocktails, and the project calculates and shows the price per cocktail along with the total price.",
    technologies: ["React.js", "Redux", "styled-components"],
  },
];

export const upcommingProjects = [
  {
    id: 2,
    name: "Rest Api for Ecommerce website ",
    img: rest,
    github: "https://github.com/slunecnicee/ecommerce-rest-api",
    decription:
      "This is gonna be an open source API. Node MongoDB eCommerce Rest API using Stripe payment methos, Node.js, shopping API , express, MongoDB, and JWT. ",
    technologies: ["Node.js", "Express", "MongoDB", "JWT", "Stripe"],
  },
  {
    id: 11,
    name: "Real-Time Messenger Clone",
    img: messenger,
    github: "https://github.com/slunecnicee/Real-Time-messenger-clone",
    note: "The development of the application is ongoing. You may still examine the code even though the app doesn't yet support picture uploads, active statuses, Google authentication, or group chats.",
    decription:
      "The program is a flawless messenger clone. You can edit your profiles, engage in real-time chat, and have private conversations with other users.  ",
    features: [
      " Real-time messaging using Pusher",
      " Sleek UI with Tailwind design",
      " Engaging animations and transition effects powered by Tailwind",
      " Full responsiveness for all devices",
      " Secure credential authentication with NextAuth",
      " Seamless integration with Google and Github authentication",
      " Client-side form validation and management using react-hook-form",
      " Server error handling with react-toast",
      " Customizable user profiles and settings",
      " In-depth knowledge of writing POST, GET, and DELETE routes in route handlers (app/api)",
      " Efficient data fetching in server React components without the need for an API",
      " Effective handling of relations between server and child components in a real-time environment",
      " Creation and management of chat rooms and channels",
    ],
    technologies: [
      "Next.js 13",
      "React",
      "Tailwind",
      "Prisma",
      "MongoDB",
      "NextAuth",
      "Pusher",
    ],
  },
];

